import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { HotelPaginationPropertiesType } from "./hotel-pagination.types";
const DEFAULT_PAGE_SIZE = 20;
export const useLoadMore = properties => {
  const $ = _c(8);
  const {
    loading,
    pageSize: t0,
    pages,
    setPages,
    totalCount
  } = properties;
  const pageSize = t0 === undefined ? DEFAULT_PAGE_SIZE : t0;
  const sentinelReference = useRef(null);
  const lockReference = useRef(false);
  const timeoutReference = useRef(null);
  let t1;
  let t2;
  if ($[0] !== loading || $[1] !== pageSize || $[2] !== pages || $[3] !== setPages || $[4] !== totalCount) {
    t1 = () => {
      const sentinel = sentinelReference.current;
      if (!sentinel || loading) {
        return;
      }
      const maxPage = Math.ceil(totalCount / pageSize);
      const observer = new IntersectionObserver(t3 => {
        const [entry] = t3;
        const currentPage = pages.at(-1) || 1;
        const hasMorePage = maxPage > currentPage;
        if (!entry?.isIntersecting || !hasMorePage || lockReference.current) {
          return;
        }
        lockReference.current = true;
        timeoutReference.current = setTimeout(() => {
          setPages(state => {
            const nextPage = currentPage + 1;
            if (state.includes(nextPage)) {
              return state;
            }
            return [...state, nextPage].sort(_temp);
          });
          lockReference.current = false;
        }, 300);
      }, {
        rootMargin: "200px"
      });
      observer.observe(sentinel);
      return () => {
        observer.disconnect();
        if (timeoutReference.current) {
          clearTimeout(timeoutReference.current);
        }
        lockReference.current = false;
      };
    };
    t2 = [loading, pageSize, pages, setPages, totalCount];
    $[0] = loading;
    $[1] = pageSize;
    $[2] = pages;
    $[3] = setPages;
    $[4] = totalCount;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      reference: sentinelReference
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
function _temp(firstPage, secondPage) {
  return firstPage - secondPage;
}